<template>
    <v-container :class="data.class" class="mx-auto cardscontainer">
        <v-row>
            <v-col v-for="(card, index) in data.cards" :key="index" cols="12" md="6" >
                <card-link :data="card"></card-link>
            </v-col>
        </v-row>
    </v-container>
</template>
<script setup>
 import cardLink from './subComponents/cardLink.vue';
</script>
<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>

<style scoped>
.cardscontainer{
    max-width: 1280px;
}
</style>